export const extractNumberFromMessage = (message) => {
  if (message) {
    const match = message.match(/\d+/);
    if (match) {
      return parseInt(match[0]); // Convert the matched string to a number
    }
  }
  return null;
};
